module.exports = __webpack_public_path__ + "static/banner-16bc44ed9b4ccc36fb98e756069f3e71.png";